<template>
  <div class="material-box-list">
    <div style="padding-bottom: 10px">
      <!-- 游戏选项框 -->
      <select-tree
        :value="filter_obj.game_ids.value"
        v-bind="filter_obj.game_ids.props"
        v-on="filter_obj.game_ids.on"
      />
      <!-- 显示母包下全部素材 -->
      <el-checkbox v-model="filter_obj.is_check_all_game.value" v-bind="filter_obj.is_check_all_game.props" v-on="filter_obj.is_check_all_game.on">显示母包下全部素材</el-checkbox>
      <!-- 素材类型 -->
      <el-select
        v-model="filter_obj.material_type.value"
        :placeholder="filter_obj.material_type.placeholder"
        size="mini"
        style="margin-left: 10px;width: 100px"
        :disabled="!((isSupportSwitchImgType && is_image_material_type) || addView.file_type === '')"
        v-on="filter_obj.material_type.on"
      >
        <el-option
          v-for="(item, index) in filter_obj.material_type.options"
          :key="index"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <!-- 素材规格 -->
      <el-select
        v-model="filter_obj.material_format_id.value"
        style="margin-left: 10px"
        size="mini"
        :disabled="Boolean(materialFormatId)"
        v-bind="filter_obj.material_format_id.props"
        v-on="filter_obj.material_format_id.on"
      >
        <el-option
          v-for="(item, index) in filter_obj.material_format_id.options"
          :key="index"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <!-- 标签 -->
      <el-select
        v-model="filter_obj.material_label_ids.value"
        v-bind="filter_obj.material_label_ids.props"
      >
        <el-option-group
          v-for="group in filter_obj.material_label_ids.options"
          :key="group.label"
          :label="group.label"
        >
          <el-option
            v-for="item in group.options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-option-group>
      </el-select>
      <!-- 名称 -->
      <el-input
        v-model="filter_obj.name.value"
        size="mini"
        style="width: 150px; margin-left: 10px"
        v-bind="filter_obj.name.props"
        v-on="filter_obj.name.on"
      />
      <el-button
        type="primary"
        size="mini"
        style="margin-left: 10px"
        @click="search"
      >
        查询
      </el-button>
      <!-- 日期筛选 -->
      <el-select
        v-model="select_params"
        size="mini"
        style="width: 175px;margin-top: 10px;"
        placeholder="请选择"
        value-key="label"
        @change="changeSortOptions"
      >
        <el-option
          v-for="item in sort_options"
          :key="item.label"
          :label="item.label"
          :value="item"
        />
      </el-select>
      <!-- 时长筛选 -->
      <el-select
        v-if="filter_obj.material_type.value === 2"
        v-model="time_params"
        size="mini"
        style="width: 175px;margin-top: 10px;margin-left: 10px;"
        placeholder="请选择"
        value-key="label"
        clearable
        @change="changeTimeOptions"
        @clear="changeTimeOptions"
      >
        <el-option
          v-for="item in time_options"
          :key="item.label"
          :label="item.label"
          :value="item"
        />
      </el-select>
      <!-- 排除使用过素材 -->
      <el-checkbox v-model="filter_obj.is_exclude_used.value" v-bind="filter_obj.is_exclude_used.props" v-on="filter_obj.is_exclude_used.on">排除使用过素材</el-checkbox>
    </div>

    <div v-loading="material_list_loading" class="material-list">
      <ul>
        <li v-for="(material_item, material_index) in material_list" :key="material_index">
          <div class="material-item" @click.prevent="selectMaterial(material_item)">
            <div
              v-if="material_item.url && material_item.url.length > 0"
              class="file-img-bg"
              :style="{ 'background-image': 'url(' + material_item.url[0].thumb_url + ')' }"
            />
            <div v-if="material_item.selected" class="pick-on">
              <i class="el-icon-success" />
            </div>
            <div style="position: relative">
              <!-- 图片 -->
              <div
                v-if="material_item.material_type === 1 || material_item.material_type === 3 || material_item.material_type === 4"
                class="file-img-box"
              >
                <el-image
                  v-for="(item, index) in material_item.url"
                  :key="index"
                  :style="{
                    float: 'left',
                    width: (material_item.url.length > 1 ? 33.33 : 100) + '%',
                    height: (material_item.url.length > 1 ? 50 : 100) + '%'
                  }"
                  :fit="material_item.url.length > 1 ? 'cover' : 'contain'"
                  :src="item.url"
                />
              </div>
              <!-- 视频 -->
              <div
                v-if="material_item.material_type === 2"
                class="file-img-box"
              >
                <video :src="material_item.url[0].url" controls />
              </div>
              <span v-if="material_item.file_mode.value" class="file-mode">{{ material_item.file_mode.value }}</span>
              <div class="tags-box" :class="{ 'tags-box-content': !material_item.material_labels.length }">
                <el-tooltip v-if="material_item.material_labels.length" :content="getMaterialAllTags(material_item.material_labels)" placement="bottom-start">
                  <div class="material-tags-list">
                    <span v-for="item in material_item.material_labels" :key="item.id" class="material-tags">
                      {{ item.label }}
                    </span>
                  </div>
                </el-tooltip>
                <span v-if="material_item.is_used" class="material-is-used">使用过</span>
              </div>
            </div>
            <el-tooltip effect="dark" :content="material_item.name" placement="bottom-start">
              <p class="material-name">{{ material_item.name }}</p>
            </el-tooltip>

            <div class="file-label">
              <div class="file-text">
                <div class="file-tag-and-time" :class="{ 'justify-end': !material_item.note }">
                  <el-tooltip v-if="material_item.note" effect="dark" :content="material_item.note" placement="bottom-start" :disabled="!material_item.note">
                    <span class="file-tag">{{ material_item.note }}</span>
                  </el-tooltip>
                  <span v-if="material_item.material_type === 2" class="file-millisecond">{{ Math.round(material_item.millisecond/1000) }}s</span>
                </div>
                <div class="file-size-and-date">
                  <span class="file-size">{{ getMaterialSize(material_item) }}</span>
                  <span>{{ material_item.updated_at }}</span>
                </div>
              </div>
            </div>
          </div>

        </li>
      </ul>
      <el-empty v-if="!material_list.length" :image-size="200" />
    </div>
    <div class="material-pagination">
      <el-checkbox v-model="check_all_config.is_check" :indeterminate="check_all_config.is_indeterminate" @change="handleCheckAllChange">全选</el-checkbox>
      <el-pagination
        layout="prev, pager, next, sizes, jumper"
        :total="material_total"
        :page-sizes="[20, 40, 80, 100]"
        :current-page="material_list_params.page"
        :page-size="material_list_params.limit"
        @current-change="onPageChange"
        @size-change="handleSizeChange"
      />
    </div>
  </div>
</template>

<script>
import { CHANNEL_INTERFACE_TYPE } from '@/enums';

// 素材列表接口
import MaterialResource from '@/api/material/index';
const materialResource = new MaterialResource();

// 素材规格列表接口
import MaterialFormatResource from '@/api/material/format';
const materialFormatResource = new MaterialFormatResource();

// 获取游戏列表接口
import AdvertisingResource from '@/api/advertising';
const advertisingResource = new AdvertisingResource();

// 获取素材标签接口
import { getMaterialLabelSelectorApi } from '@/api/material/label';

export default {
  components: {
    'select-tree': () => import('@/components/select-tree'),
  },
  props: {
    /**
     * 平台
     */
    advertiser: {
      type: String,
      default: '',
    },
    addView: {
      type: Object,
      default: () => {
        return {};
      },
    },
    thumbMaterialList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    /** 素材限制 - 支持多个限制条件 */
    restriction: {
      type: Array,
      default: () => {
        return [];
      },
    },
    loaclMaterial: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 素材规格id
    materialFormatId: {
      type: [String, Number],
      default: '',
    },
    /** 游戏ID */
    gameId: {
      type: Number,
      default: null,
    },
    /**
     * 是否支持切换图片类型
     * - 单图[image - 1]
     * - 组图[element_story - 4]
     */
    isSupportSwitchImgType: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 素材列表参数
      material_list_params: {
        page: 1,
        limit: 20,
        sort_prop: 'updated_at',
        sort_order: 'DESC',
        local_material_ids: this.loaclMaterial?.length ? [...new Set(this.loaclMaterial)] : null,
      },
      time_params: undefined,
      select_params: {
        label: '时间由近->远',
        value: { sort_prop: 'updated_at', sort_order: 'DESC' },
      },
      material_list_loading: false, // 素材列表是否加载
      material_list: [], // 素材列表数据
      material_total: 0, // 素材总数
      material_restriction: {},
      // 素材规格列表参数
      material_format_list_params: {
        page: 1,
      },
      filter_obj: {
        // 游戏
        game_ids: {
          label: '游戏',
          placeholder: '请选择游戏',
          props: {
            options: [],
            ischeckbox: false,
            'check-on-click-node': true,
            props: {
              value: 'id',
              label: 'name',
              children: 'children',
            },
            'select-props': {
              placeholder: '请选择游戏',
              clearable: true,
              accordion: true,
              size: 'small',
            },
          },
          on: {
            getValue: async(game_id) => {
              this.filter_obj.game_ids.value = game_id;
              this.material_list_params.game_ids = game_id ? [this.filter_obj.game_ids.value] : null;

              // 获取素材标签选项
              this.filter_obj.material_label_ids.value = [];
              delete this.material_list_params.material_label_ids;
              this.filter_obj.material_label_ids.options = await this.getMaterialLabelSelector({ ...(game_id && { game_id }) });
            },
          },
          value: null,
        },
        // 素材类型
        material_type: {
          options: [
            {
              label: '图片',
              value: 1,
            },
            {
              label: '视频',
              value: 2,
            },
            {
              label: '落地页',
              value: 3,
            },
            {
              label: '组图',
              value: 4,
            },
          ],
          value: null,
          on: {
            change: (val) => {
              this.selectMateriaType(val);
            },
          },
        },
        // 素材标准
        material_format_id: {
          label: '素材标准',
          options: [],
          value: null,
          props: {
            placeholder: '请选择素材规格',
            size: 'small',
            clearable: true,
          },
          on: {
            change: (val) => {
              if (!val) {
                this.material_list_params.material_format_id = null;
                this.onPageChange(1);
                return;
              }

              const temp_restriction = this.material_format_list.filter((item) => {
                return item.id === val;
              })[0];
              this.material_restriction = temp_restriction;
              this.material_list_params.material_format_id = val;
              this.onPageChange(1);
            },
          },
        },
        // 标签
        material_label_ids: {
          options: [],
          props: {
            class: 'ml-10',
            placeholder: '请选择素材标签',
            size: 'mini',
            multiple: true,
            filterable: true,
            clearable: true,
            collapseTags: true,
          },
          value: '',
        },
        // 名称
        name: {
          props: {
            placeholder: '请输入素材名称',
            size: 'small',
          },
          value: '',
        },
        // 显示母包下全部素材
        is_check_all_game: {
          props: {
            trueLabel: '1',
            falseLabel: '0',
            style: {
              marginLeft: '10px',
              marginRight: 0,
            },
          },
          value: '0',
          on: {
            change: this.search,
          },
        },
        // 排除使用过素材
        is_exclude_used: {
          props: {
            trueLabel: '1',
            falseLabel: '0',
            style: {
              marginLeft: '10px',
              marginRight: 0,
            },
          },
          value: '0',
          on: {
            change: this.search,
          },
        },
      },
      // 类型对象
      type_obj: {
        image: 1,
        video: 2,
        element_story: 4,
      },
      // 排序
      sort_options: [
        { label: '时间由近->远', value: { sort_prop: 'updated_at', sort_order: 'DESC' }},
        { label: '时间由远->近', value: { sort_prop: 'updated_at', sort_order: 'ASC' }},
        { label: '名称编号由大->小', value: { sort_prop: 'name', sort_order: 'DESC' }},
        { label: '名称编号由小->大', value: { sort_prop: 'name', sort_order: 'ASC' }},
      ],
      // 时间筛选
      time_options: [
        { label: '小于30S', value: { max_millisecond: 30000 }},
        { label: '大于30S', value: { min_millisecond: 30000 }},
      ],
      // 全选配置
      check_all_config: {
        is_check: false,
        is_indeterminate: false,
      },
    };
  },
  computed: {
    /**
     * 是否为图片类型素材
     * - 单图[image - 1]
     * - 组图[element_story - 4]
     * @returns {boolean}
     */
    is_image_material_type() {
      const material_type = this.type_obj[this.addView.file_type];
      return [1, 4].includes(material_type);
    },
    library_channel_interface() {
      return this.advertiser === CHANNEL_INTERFACE_TYPE.JRTT_V3
        ? CHANNEL_INTERFACE_TYPE.JRTT
        : this.advertiser;
    },
  },
  created() {
    if (this.materialFormatId || this.gameId) {
      this.materialFormatId && (this.filter_obj.material_format_id.value = this.materialFormatId);
      this.gameId && (this.filter_obj.game_ids.value = this.gameId);
      this.search();
    }
  },
  async mounted() {
    // 判断是否存在广告商，存在就添加到获取素材列表参数里
    if (this.library_channel_interface) {
      this.material_list_params.channel_interface = this.library_channel_interface;
    }

    Object.assign(this.filter_obj.material_type, {
      value: this.type_obj[this.addView.file_type],
      ...((this.isSupportSwitchImgType && this.is_image_material_type) && { options: this.filter_obj.material_type.options.filter(({ value }) => [1, 4].includes(value)) }),
    });
    this.selectMateriaType(this.filter_obj.material_type.value);

    this.getGameList({ is_parent: 0 }).then((res) => {
      for (let i = 0; i < res.list.length; i++) {
        res.list[i]['disabled'] = true;
      }
      this.filter_obj.game_ids.props.options = res.list;
      // 渲染游戏过滤项的值
      this.filter_obj.game_ids.value = null;
      this.$nextTick(() => (this.filter_obj.game_ids.value = this.gameId));
    });

    // 获取素材标签选项
    this.filter_obj.material_label_ids.options = await this.getMaterialLabelSelector({ ...(this.gameId && { game_id: this.gameId }) });
  },
  methods: {
    /**
     * 素材标签选择器
     * @param {Object} params 请求参数
     * @returns {Promise<Object[]>}
     */
    getMaterialLabelSelector(params) {
      return new Promise((resolve, reject) => {
        getMaterialLabelSelectorApi(params).then((res) => {
          const options = (res?.list || []).map(({ game_name, material_labels }) => {
            return {
              label: game_name,
              options: material_labels.map(({ id: value, label_name: label }) => ({ label, value })),
            };
          });
          resolve(options);
        }).catch(reject);
      });
    },
    // 获取素材所有标签
    getMaterialAllTags: function(tags) {
      return (tags || []).map(({ label }) => label).join('、');
    },
    // 选择素材
    selectMaterial: function(item) {
      /**
       * 头条素材不存在 item.file_mode.code 时，即为不符合要求的不可用素材，所以这些素材不可选
       * 理应由后端过滤掉不可用素材，待后端优化后，即可移除该if逻辑判断
       */
      if (!item.file_mode.code && this.library_channel_interface && [CHANNEL_INTERFACE_TYPE.JRTT].includes(this.library_channel_interface)) {
        this.$message({
          message: '该素材尺寸大小不符合',
          type: 'warning',
        });
        return;
      }
      if (this.addView.is_radio) {
        this.material_list = this.material_list.map((it) => {
          it.selected = false;
          return it;
        });
      }
      item.selected = !item.selected;
      this.handleCheckAllStatus();
      this.$emit('select-material', item);
    },
    // 选择类型
    selectMateriaType: function(val) {
      this.material_format_list_params['type'] = val;
      this.material_list_params['material_type'] = val;

      this.getMaterialFormatList(this.material_format_list_params).then((res) => {
        this.material_format_list = res.list;
        let options = res.list || [];

        // 素材限制逻辑
        if (this.restriction.length) {
          options = options.filter(o => this.restriction.some(r => this.getRestrictionResult(r, o)));
          if (options.length) {
            this.filter_obj.material_format_id.value = options[0].id;
            Object.assign(this.material_list_params, { material_format_id: options[0].id });
          }
        }

        this.filter_obj.material_format_id.options = options.map((item) => {
          return {
            label: item.name,
            value: item.id,
          };
        });

        if (this.filter_obj.material_format_id.options.length > 0) {
          this.getMaterialList(this.material_list_params).then((res) => {
            this.restMaterialList(res);
          });
        } else {
          this.material_list = [];
        }
      });
    },
    // 获取素材规格列表
    getMaterialFormatList: function(params) {
      return new Promise((resolve, reject) => {
        materialFormatResource
          .getMaterialFormatListApi(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 获取游戏列表
    getGameList: function(params) {
      return new Promise((resolve, reject) => {
        advertisingResource
          .getGameListApi(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onPageChange: function(val) {
      this.material_list_params.page = val;
      this.getMaterialList(this.material_list_params).then((res) => {
        this.restMaterialList(res);
      });
    },
    handleSizeChange(val){
      this.material_list_params.limit = val;
      this.getMaterialList(this.material_list_params).then((res) => {
        this.restMaterialList(res);
      });
    },
    search: function() {
      const filter_params = {};

      for (const key in this.filter_obj) {
        const params_value = this.filter_obj[key].value;
        if (params_value || typeof (params_value) === 'boolean') {
          if (key === 'game_ids') {
            filter_params[key] = [this.filter_obj[key].value];
          } else {
            filter_params[key] = this.filter_obj[key].value;
          }
        } else {
          filter_params[key] = null;
        }
      }

      this.material_list_params = Object.assign(this.material_list_params, filter_params);
      this.onPageChange(1);
    },
    // 重置素材列表
    restMaterialList: function(res) {
      this.material_list = res.list.map((item) => {
        return {
          ...item,
          selected: false,
        };
      });
      for (let i = 0; i < this.material_list.length; i++) {
        const item = this.material_list[i];
        item['selected'] = !!this.isMaterialExist(item);
      }

      this.material_total = res.page_info.total_number;
      this.handleCheckAllStatus();
    },
    // 素材是否存在
    isMaterialExist: function(item) {
      for (var i = 0; i < this.thumbMaterialList.length; i++) {
        let material_item = this.thumbMaterialList[i];
        if (item.id === material_item.id) {
          material_item = item;
          return true;
        }
      }
      return false;
    },
    // 获取素材列表
    getMaterialList: function(params) {
      this.material_list_loading = true;
      return new Promise((resolve, reject) => {
        materialResource
          .getMaterialListApi(params)
          .then((response) => {
            resolve(response);
            this.material_list_loading = false;
          })
          .catch((error) => {
            reject(error);
            this.material_list_loading = false;
          });
      });
    },

    /**
      *  改变素材排序方式
      * @param option 当前选中的排序方式
     */
    changeSortOptions(option){
      for (const key in option['value']){
        this.material_list_params[key] = option['value'][key];
      }
      this.onPageChange(1);
    },

    /**
      *  改变筛选时间
      * @param val 当前选中时间
    */
    changeTimeOptions(val){
      // 清空选择
      this.material_list_params.min_millisecond = undefined;
      this.material_list_params.max_millisecond = undefined;
      if (val){
        this.material_list_params = {
          ...this.material_list_params,
          ...val.value,
        };
      }

      this.onPageChange(1);
    },
    /**
     * 获取素材限制比对结果
     * @param option 当前选中的排序方式
     */
    getRestrictionResult(restriction, target) {
      let result = true;
      for (const key of Object.keys(restriction)) {
        switch (key) {
          case 'width':
            result = restriction[key] === target[key];
            break;
          case 'height':
            result = restriction[key] === target[key];
            break;
          case 'min_size':
            result = restriction[key] < target[key];
            break;
          case 'max_size':
            result = restriction[key] > target[key];
            break;
          case 'min_millisecond':
            result = restriction[key] < target[key];
            break;
          case 'max_millisecond':
            result = restriction[key] > target[key];
            break;
          default:
            result = true;
            break;
        }
        if (!result) {
          return result;
        }
      }
      return result;
    },
    /**
     * 获取素材大小
     * @param {number} material 素材
     * @returns {string}
     */
    getMaterialSize(material) {
      const { material_type, size } = material;
      const is_video = material_type === 2;
      const getResult = (num) => Math.round(num * 100) / 100;
      return is_video ? `${getResult(size / 1024 / 1024)}MB` : `${getResult(size / 1024)}KB`;
    },
    /**
     * 处理全选事件
     * @param {boolean} is_select_all 是否全选
     * @returns {void}
     */
    handleCheckAllChange(is_select_all) {
      /** 同步单选的判断逻辑 - start */
      const is_valid = this.material_list.every(material_item => material_item.file_mode.code);
      if (!is_valid && this.library_channel_interface && [CHANNEL_INTERFACE_TYPE.JRTT].includes(this.library_channel_interface)) {
        this.$message({
          message: '存在素材尺寸大小不符合',
          type: 'warning',
        });
        this.handleCheckAllStatus();
        return;
      }
      /** 同步单选的判断逻辑 - end */

      this.material_list.forEach(material_item => {
        material_item.selected = is_select_all;
      });
      this.handleCheckAllStatus();
      this.$emit('select-all-material', this.material_list);
    },
    /**
     * 处理全选checkbox状态
     * @returns {void}
     */
    handleCheckAllStatus() {
      const selected_count = this.material_list.filter(item => item.selected).length;
      const total_count = this.material_list.length;

      Object.assign(this.check_all_config, {
        is_check: total_count > 0 && selected_count === total_count,
        is_indeterminate: selected_count > 0 && selected_count < total_count,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.material-box-list {
  .material-list {
    width: 100%;
    height: 385px;
    margin-top: 10px;
    overflow: auto;
    ul {
      list-style: none;
      margin: 0px;
      padding: 0;
      li {
        width: 25%;
        float: left;
        padding: 10px;
        .material-item {
          position: relative;
          height: 300px;
          .file-img-bg {
            position: absolute;
            width: 100%;
            height: 200px;
            background-size: auto 200px;
            opacity: 0.4;
            -webkit-filter: blur(10px);
            filter: blur(10px);
          }
          .file-mode {
            position: absolute;
            top: 0;
            right: 0;
            padding: 3px 10px;
            border-radius: 2px;
            color: #fff;
            background-color: #000;
          }
          .tags-box {
            position: absolute;
            bottom: 0;
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .material-tags-list {
              position: relative;
              display: flex;
              overflow: hidden;
              margin-right: 5px;
              flex: 1;
              mask: linear-gradient(to right, #000 90%, transparent);
              .material-tags {
                margin-right: 5px;
                padding: 3px 10px;
                border-radius: 4px;
                color: #fff;
                background-color: green;
                white-space: nowrap;
              }
            }
            .material-is-used {
              padding: 3px 10px;
              border-radius: 2px;
              color: #fff;
              background-color: #2096f5;
              white-space: nowrap;
            }
          }
          .tags-box-content {
            justify-content: flex-end;
          }
          .file-img-box {
            height: 200px;
            position: relative;
            video {
              position: absolute;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
              width: 100%;
              max-width: 100%;
              max-height: 100%;
              margin: auto;
            }
          }
          .pick-on {
            position: absolute;
            left: -2px;
            right: -2px;
            top: -2px;
            bottom: -2px;
            border: 2px #2096f5 solid;
            i {
              color: #2096f5;
              font-size: 20px;
              padding: 10px;
            }
          }
          .material-name {
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            display: -webkit-box;
            -webkit-box-orient: vertical;
          }
          .file-label {
            line-height: 15px;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            .file-text {
              display: flex;
              flex-direction: column;
              line-height: 30px;
              .file-tag-and-time {
                display: flex;
                justify-content: space-between;
                color: firebrick;
                .file-tag {
                  flex: 1;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
              }
              .file-size-and-date {
                display: flex;
                justify-content: space-between;
                color: #aaa;
              }
            }
          }
        }
      }
    }
  }
  .material-pagination {
    display: flex;
    justify-content: space-between;
    padding: 30px 15px 0;
  }
  .justify-end {
    justify-content: flex-end !important;
  }
}
</style>
